<script setup lang="ts">
defineProps({
  craftable: {
    type: Object as PropType<CraftItem>,
    required: true,
  },
});

const emit = defineEmits(["confirm", "back", "close", "backToIndex"]);
</script>

<template>
  <div class="space-y-6">
    <div class="flex flex-col items-center gap-4 text-neutral-300">
      <img
        :src="getPortraitItemImage(craftable.imageId)"
        class="w-32 h-32 border border-neutral-700" />
      <div class="text-center">
        <p class="text-sm">
          {{ $t("main.modalCraftConfirm.youAreAboutToCraft") }}
        </p>
        <p class="font-bold truncate">
          {{ $t(`${craftable.translationId}.title`) }}
          {{ $t(`${craftable.translationId}.subtitle`) }}
        </p>
      </div>
    </div>
    <div class="flex flex-col items-center gap-2">
      <h4 class="text-neutral-300 text-xs">
        {{ $t("main.modalCraftConfirm.youWillBurn") }}
      </h4>
      <CardCraftList
        :crafting-requirements="craftable.ingredients"
        :detail-view="true"
        :can-emit="true"
        @click="emit('backToIndex', $event)" />
    </div>
    <div class="bg-primary-900 rounded-sm py-2">
      <div class="flex gap-3 pl-3 pr-4">
        <NuxtIcon
          name="mdi:warning"
          class="w-4 shrink-0 text-warning-300 pt-5" />
        <p class="text-sm text-warning-300">
          {{
            $t("main.modalCraftConfirm.collectiblesUsedForCraftWillBeRemoved")
          }}
        </p>
      </div>
    </div>
    <div class="flex justify-center gap-4">
      <BaseButtonSubmit
        @click="emit('confirm')"
        :text="$t('main.modalCraftConfirm.craftCollectible')"
        :contextual-styles="true" />
      <BaseButtonCancel
        @click="emit('back')"
        :text="$t('main.modalCraftConfirm.back')"
        :contextual-styles="true" />
    </div>
  </div>
</template>
